import { render, staticRenderFns } from "./site-setup-location-details-form.component.vue?vue&type=template&id=ec826eaa"
import script from "./site-setup-location-details-form.component.ts?vue&type=script&lang=ts&external"
export * from "./site-setup-location-details-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./site-setup-location-details-form.component.vue?vue&type=style&index=0&id=ec826eaa&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec826eaa')) {
      api.createRecord('ec826eaa', component.options)
    } else {
      api.reload('ec826eaa', component.options)
    }
    module.hot.accept("./site-setup-location-details-form.component.vue?vue&type=template&id=ec826eaa", function () {
      api.rerender('ec826eaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site-setup/site-setup-location-form/site-setup-location-details-form.component.vue"
export default component.exports